import {
  animate,
  animation,
  AnimationTriggerMetadata,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

export function getFadeInTransition(transitionLength: number): any {
  return trigger('fade', [
    transition('void => *', [
      style({ opacity: 0 }),
      animate(transitionLength, style({ opacity: 1 })),
    ]),
  ]);
}

const DEFAULT_DURATION = 1000;

export function fadeInUpBigOnEnter(options?: any): AnimationTriggerMetadata {
  return trigger((options && options.anchor) || 'fadeInUpBigOnEnter', [
    transition(
      ':enter',
      [
        style({ visibility: 'hidden' }),
        animation([
          animate(
            500,
            keyframes([
              style({
                visibility: 'visible',
                opacity: 0,
                transform: 'translate3d(0, {{translate}}, 0)',
                easing: 'ease',
                offset: 0,
              }),
              style({
                opacity: 1,
                transform: 'translate3d(0, 0, 0)',
                easing: 'ease',
                offset: 1,
              }),
            ]),
          ),
        ]),
      ],
      {
        params: {
          delay: (options && options.delay) || 0,
          duration: (options && options.duration) || DEFAULT_DURATION,
          translate: (options && options.translate) || '2000px',
        },
      },
    ),
    transition(':leave', [
      animate('200ms ease-in', style({ transform: 'translateY(200%)' })),
    ]),
  ]);
}

export function getFadeOutTransition(transitionLength: number): any {
  return trigger('fadeOut', [
    transition('void => *', [
      style({ opacity: 1 }),
      animate(transitionLength, style({ opacity: 0 })),
    ]),
  ]);
}
